import React from 'react';
import { NotificationType, notifyCustom, Button, intl } from 'ehs-react';

export function showErrorWithReloadButton(message: string, title?: string) {
  notifyCustom(closingCallback => {
    return {
      closeOnOverlayClicked: false,
      type: NotificationType.ERROR,
      title: title ? title : intl('common.error'),
      content: <div dangerouslySetInnerHTML={{ __html: message }} />,
      actions: (
        <>
          <Button
            variant="primary"
            text={intl('view.button.reload')}
            onClickCapture={() => window.location.reload()}
          />
        </>
      )
    };
  });
}
